import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

type TrackListItemClickedPayload = TrackingPayload;

export const trackListItemClickedAnalytics = (payload: TrackListItemClickedPayload) => {
    track(TrackingEvents.Bidding.ListItemClicked, payload);
};

export const useTrackListItemClickedAnalytics = (itemId: number, catalogId: number) => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackListItemClickedAnalytics({
            catalogId,
            itemId,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [catalogId, itemId, pathname, url]);
};
